var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "body" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.step != 4
      ? _c("div", { staticClass: "container custom-container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "side-bar col-md-2 pl-0 pr-0" }, [
              _c("div", [
                _c(
                  "p",
                  {
                    class: {
                      "numb-text-active": _vm.step == 1,
                      "numb-text-done": _vm.step > 1,
                      "numb-text-next": _vm.step < 1,
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "numb",
                        class: {
                          "numb-blue": _vm.step == 1,
                          "numb-green": _vm.step > 1,
                          "numb-grey": _vm.step < 1,
                        },
                      },
                      [
                        _vm.step == 1
                          ? _c("span", [_vm._v("1")])
                          : _c("span", [
                              _c("i", {
                                staticClass: "fa fa-check",
                                staticStyle: { "font-size": "9px" },
                              }),
                            ]),
                      ]
                    ),
                    _vm._v(
                      "\n                        ORCID validation\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    class: {
                      "numb-text-active": _vm.step == 2,
                      "numb-text-done": _vm.step > 2,
                      "numb-text-next": _vm.step < 2,
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "numb",
                        class: {
                          "numb-blue": _vm.step == 2,
                          "numb-green": _vm.step > 2,
                          "numb-grey": _vm.step < 2,
                        },
                      },
                      [
                        _vm.step == 2 || _vm.step == 1
                          ? _c("span", [_vm._v("2")])
                          : _c("span", [
                              _c("i", {
                                staticClass: "fa fa-check",
                                staticStyle: { "font-size": "9px" },
                              }),
                            ]),
                      ]
                    ),
                    _vm._v(
                      "\n                        Connect ORCID\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    class: {
                      "numb-text-active": _vm.step == 3,
                      "numb-text-done": _vm.step > 3,
                      "numb-text-next": _vm.step < 3,
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "numb-last",
                        class: {
                          "numb-blue": _vm.step == 3,
                          "numb-green": _vm.step > 3,
                          "numb-grey": _vm.step < 3,
                        },
                      },
                      [
                        _vm.step > 0
                          ? _c("span", [_vm._v("3")])
                          : _c("span", [
                              _c("i", {
                                staticClass: "fa fa-check",
                                staticStyle: { "font-size": "9px" },
                              }),
                            ]),
                      ]
                    ),
                    _vm._v(
                      "\n                        Author information\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-10 pl-0 pr-0" }, [
              _vm.article
                ? _c("div", { staticClass: "col-md-12 pl-0 pr-0 mb-4" }, [
                    _c("b", [_vm._v("Title:")]),
                    _vm._v(" "),
                    _c("small", [_vm._v(_vm._s(_vm.article.title))]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "panel" }, [
                _c("div", { staticClass: "panel__header" }, [
                  _c("h1", { staticClass: "panel__title" }, [
                    _vm.step == 1
                      ? _c("span", [_vm._v("ORCID validation")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.step == 2
                      ? _c("span", [_vm._v("Connect ORCID")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.step == 3
                      ? _c("span", [_vm._v("Review author information")])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "panel__body" }, [
                  _vm.step == 1
                    ? _c("div", [
                        _vm.orcid &&
                        _vm.user &&
                        _vm.orcid.orcid != _vm.user.orcid
                          ? _c("div", [
                              _c("div", { staticClass: "panel__body_main" }, [
                                _c("h2", { staticClass: "text-center mb-5" }, [
                                  _vm._v(
                                    "We have found multiple ORCID accounts, please select one that you\n                                        want to validate and connect with JMIR.\n                                    "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link-multiple-orcid",
                                      attrs: { href: "javascript:;" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectOrcid(
                                            _vm.orcid.orcid
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "multiple-orcid d-flex mb-2",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "mr-auto" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  "Name: " +
                                                    _vm._s(_vm.orcid.name) +
                                                    " "
                                                ),
                                                _vm.orcid.orcid ==
                                                _vm.selectedOrcid
                                                  ? _c("small", [
                                                      _vm._v("(current)"),
                                                    ])
                                                  : _vm._e(),
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("img", {
                                                staticStyle: {
                                                  width: "18px",
                                                  "margin-right": "3px",
                                                },
                                                attrs: {
                                                  src: "https://asset.jmir.pub/assets/static/images/orcidGreen.svg",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("b", [
                                                _vm._v(_vm._s(_vm.orcid.orcid)),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._m(1),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link-multiple-orcid",
                                      attrs: { href: "javascript:;" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectOrcid(
                                            _vm.user.orcid.orcid
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "multiple-orcid d-flex mb-2",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "mr-auto" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  "Name:\n                                                    "
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(_vm.user.first_name)
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(_vm.user.last_name)
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _vm.user.orcid.orcid ==
                                                _vm.selectedOrcid
                                                  ? _c("small", [
                                                      _vm._v("(current)"),
                                                    ])
                                                  : _vm._e(),
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("img", {
                                                staticStyle: {
                                                  width: "18px",
                                                  "margin-right": "3px",
                                                },
                                                attrs: {
                                                  src: "https://asset.jmir.pub/assets/static/images/orcidGreen.svg",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.user.orcid.orcid)
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._m(2),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ])
                          : _c("div", [
                              _c(
                                "div",
                                { staticClass: "panel__body_main text-center" },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-check green-checkmark",
                                  }),
                                  _vm._v(" "),
                                  _c("h2", [_vm._v("Validation successful!")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "Thank you for validating your ORCID"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticStyle: {
                                      width: "18px",
                                      "margin-right": "3px",
                                    },
                                    attrs: {
                                      src: "https://asset.jmir.pub/assets/static/images/orcidGreen.svg",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.orcid
                                    ? _c("b", [_vm._v(_vm._s(_vm.orcid.orcid))])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#9d9d9d" } },
                                    [_vm._v("| ")]
                                  ),
                                  _c("b", [
                                    _vm._v("Name: " + _vm._s(_vm.orcid.name)),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._m(3),
                            ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step == 2
                    ? _c("div", [
                        !_vm.user
                          ? _c("div", [
                              _c(
                                "div",
                                { staticClass: "panel__body_main text-center" },
                                [
                                  _c("h2", [
                                    _vm._v(
                                      "Connect ORCID to JMIR Account (optional)"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "If you connect your validated ORCID to your JMIR account, you can skip the authentication step for future submissions."
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "container mt-5" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "row justify-content-center",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-4 text-center bg-light-blue mb-2 margin-box-1",
                                          },
                                          [
                                            _c("b", { staticClass: "fs" }, [
                                              _vm._v(
                                                "Already have an account?"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "btn-custom btn-custom-blue mt-4",
                                                staticStyle: {
                                                  padding: "10px",
                                                },
                                                attrs: {
                                                  href:
                                                    "https://accounts.jmir.pub?redirectTo=" +
                                                    _vm.url,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                    Sign into JMIR\n                                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-4 text-center bg-light-blue mb-2 margin-box-2",
                                          },
                                          [
                                            _c("b", { staticClass: "fs" }, [
                                              _vm._v("Don't have an account?"),
                                            ]),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "btn-custom btn-custom-blue mt-4",
                                                staticStyle: {
                                                  padding: "10px",
                                                },
                                                attrs: {
                                                  href:
                                                    "https://accounts.jmir.pub/register?redirectTo=" +
                                                    _vm.url,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                    Create JMIR account\n                                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ])
                          : _c("div", [_vm._m(4)]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step == 3
                    ? _c(
                        "div",
                        [
                          _c("author", {
                            attrs: {
                              article: _vm.article,
                              author: _vm.author,
                              index: _vm.index,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "container mt-4 d-flex justify-content-end",
                staticStyle: { "padding-right": "0px !important" },
              },
              [
                _vm.step > 1
                  ? _c(
                      "button",
                      {
                        staticClass: "btn-custom btn-custom-grey mr-2",
                        attrs: { href: "javascript:;" },
                        on: { click: _vm.previous },
                      },
                      [
                        _c("i", { staticClass: "fas fa-chevron-left mr-2" }),
                        _vm._v(
                          "\n                        Go back\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.step != 3
                  ? _c(
                      "button",
                      {
                        staticClass: "btn-custom btn-custom-blue",
                        attrs: { href: "javascript:;" },
                        on: { click: _vm.next },
                      },
                      [
                        _vm._v(
                          "\n                        Continue\n                        "
                        ),
                        _c("i", { staticClass: "fas fa-chevron-right ml-2" }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.step == 3
                  ? _c(
                      "button",
                      {
                        staticClass: "btn-custom btn-custom-blue",
                        attrs: { href: "javascript:;" },
                        on: { click: _vm.next },
                      },
                      [
                        _vm._v(
                          "\n                        Finish\n                        "
                        ),
                        _c("i", { staticClass: "fas fa-chevron-right ml-2" }),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.step == 4
      ? _c("div", { staticClass: "container custom-container" }, [_vm._m(5)])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", [
      _c("div", { staticClass: "container-fluid bg-white mb-5" }, [
        _c("div", { staticClass: "container pl-1 pt-3 pb-3" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.jmirpublications.com",
                target: "_blank",
              },
            },
            [
              _c("img", {
                staticStyle: { width: "255px" },
                attrs: { src: "/public/images/JMIR-logo@2x.png" },
              }),
            ]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mt12" }, [
      _c("i", { staticClass: "fa fa-chevron-right text-right" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mt12" }, [
      _c("i", { staticClass: "fa fa-chevron-right text-right" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel__body_footer" }, [
      _c("b", [_vm._v("Note:")]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("small", [
        _vm._v(
          "If this ORCID does nor belong to you, it is possible that another user is logged in to ORCID on your browser. Please go to "
        ),
        _c("a", { attrs: { href: "https://orcid.org/", target: "_blank" } }, [
          _vm._v("www.orcid.org"),
        ]),
        _vm._v(", logout, and click the validation link in the email again."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel__body_main text-center" }, [
      _c("i", { staticClass: "fa fa-check green-checkmark mb-3" }),
      _vm._v(" "),
      _c("h2", [
        _vm._v("Your ORCID is successfully connected to JMIR Account"),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("Continue to review author information")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel__body_main text-center" }, [
      _c("i", { staticClass: "fa fa-check green-checkmark mb-3" }),
      _vm._v(" "),
      _c("h2", { staticClass: "pl-5 pr-5" }, [
        _vm._v("Thank you for validating your ORCID and\n            "),
        _c("br"),
        _vm._v("reviewing your author details!"),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn-custom btn-custom-blue", attrs: { href: "#" } },
        [_vm._v("Explore our journals")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }